module.exports = __webpack_public_path__ + "static/media/Venti.965e940e.png";